import DsAudit from './DsAudit'

export default Vue => {
  Vue.component(DsAudit.name, DsAudit)
}



// WEBPACK FOOTER //
// ./src/components/dsaudit/index.js